"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageCropperModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_easy_crop_1 = __importDefault(require("react-easy-crop"));
const lucide_react_1 = require("lucide-react");
const framer_motion_1 = require("framer-motion");
const createImage = (url) => new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => reject(error));
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = url;
});
const getCroppedImg = async (imageSrc, pixelCrop) => {
    const image = await createImage(imageSrc);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx)
        throw new Error('Canvas context not found');
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;
    ctx.drawImage(image, pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height, 0, 0, pixelCrop.width, pixelCrop.height);
    return new Promise((resolve) => {
        canvas.toBlob((blob) => {
            if (blob) {
                resolve(new File([blob], 'cropped_image.png', { type: 'image/png' }));
            }
        }, 'image/png');
    });
};
const ImageCropperModal = ({ imageSrc, aspect = 1, cropShape = 'round', onComplete, onCancel }) => {
    const [crop, setCrop] = (0, react_1.useState)({ x: 0, y: 0 });
    const [zoom, setZoom] = (0, react_1.useState)(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = (0, react_1.useState)(null);
    const [isProcessing, setIsProcessing] = (0, react_1.useState)(false);
    const handleCropComplete = (0, react_1.useCallback)((_croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);
    const handleSave = async () => {
        if (!croppedAreaPixels)
            return;
        setIsProcessing(true);
        try {
            const file = await getCroppedImg(imageSrc, croppedAreaPixels);
            onComplete(file);
        }
        catch (e) {
            console.error(e);
            alert('Resim kırpılırken hata oluştu.');
        }
        finally {
            setIsProcessing(false);
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: "modal-overlay", onClick: onCancel, style: {
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.8)',
            zIndex: 100000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }, children: (0, jsx_runtime_1.jsxs)(framer_motion_1.motion.div, { className: "modal-content", onClick: e => e.stopPropagation(), initial: { scale: 0.9, opacity: 0 }, animate: { scale: 1, opacity: 1 }, exit: { scale: 0.9, opacity: 0 }, style: { width: '400px', overflow: 'hidden' }, children: [(0, jsx_runtime_1.jsxs)("div", { className: "modal-header", children: [(0, jsx_runtime_1.jsx)("h3", { children: "Resmi K\u0131rp" }), (0, jsx_runtime_1.jsx)("button", { className: "close-btn", onClick: onCancel, children: (0, jsx_runtime_1.jsx)(lucide_react_1.X, { size: 20 }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "modal-body", style: { padding: 0 }, children: [(0, jsx_runtime_1.jsx)("div", { style: { position: 'relative', width: '100%', height: '300px', background: '#000' }, children: (0, jsx_runtime_1.jsx)(react_easy_crop_1.default, { image: imageSrc, crop: crop, zoom: zoom, aspect: aspect, cropShape: cropShape, onCropChange: setCrop, onZoomChange: setZoom, onCropComplete: handleCropComplete }) }), (0, jsx_runtime_1.jsx)("div", { style: { padding: '16px', background: '#2b2d31' }, children: (0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', alignItems: 'center', gap: '12px' }, children: [(0, jsx_runtime_1.jsx)(lucide_react_1.ZoomOut, { size: 18, color: "#b5bac1" }), (0, jsx_runtime_1.jsx)("input", { type: "range", value: zoom, min: 1, max: 3, step: 0.1, "aria-labelledby": "Zoom", onChange: (e) => setZoom(Number(e.target.value)), style: { flex: 1 } }), (0, jsx_runtime_1.jsx)(lucide_react_1.ZoomIn, { size: 18, color: "#b5bac1" })] }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "modal-footer", style: { display: 'flex', justifyContent: 'space-between' }, children: [(0, jsx_runtime_1.jsx)("button", { className: "btn-cancel", onClick: onCancel, children: "\u0130ptal" }), (0, jsx_runtime_1.jsx)("button", { className: "btn-brand", onClick: handleSave, disabled: isProcessing, children: isProcessing ? 'İşleniyor...' : 'Uygula' })] })] }) }));
};
exports.ImageCropperModal = ImageCropperModal;
